<template>
  <div class="text-left">
    <h4 class="text-center">
      Termos de Responsabilidade Termo de aceite Televet Brasil
    </h4>
    <p>
      O uso da teleconsulta no Video Front oferecidos pela TeleVet Brasil está
      condicionado à aceitação e ao cumprimento deste Termo de Aceite pelas
      pessoas físicas que o acessem.
    </p>
    <p>
      Ao clicar no botão "CADASTRAR", declaro estar de acordo em realizar uma
      teleconsulta com um médico veterinário da TeleVet Brasil.
    </p>
    <p>
      Para isso, DECLARO estar ciente de que as informações resultantes desta
      teleconsulta serão registradas no prontuário do meu pet, sendo garantido a
      confidencialidade e o sigilo entre profissional e tutor.
    </p>
    <p>
      Ainda, AUTORIZO que a equipe TeleVet Brasil tenha acesso TOTAL aos meus
      dados e aos dados do meu pet, bem como histórico de atendimento
      cadastrados no sistema PetTree, com a finalidade de obter todos os dados
      necessários para garantir o melhor atendimento veterinário ao meu pet.
    </p>
    <p>
      Por fim, PERMITO o acesso à câmera e ao microfone do meu computador para
      participar da teleconsulta, bem como o uso da minha imagem e voz para
      qualquer fim que seja necessário.
    </p>
  </div>
</template>

<script>
export default {
  data: () => ({}),

  methods: {},
};
</script>
